import { useReducer } from 'react'
import effects from 'app/effects/effects'
import MessageAlert from 'app/components/MessageAlert'
import { useDispatch } from 'react-redux'
import { useIntl } from 'react-intl'

export const ActionType = {
  SET_PUBLICLINK: 'SET_PUBLICLINK',
  SET_LOADER: 'SET_LOADER',
}

const initialState = {
  publicList: [],
  isLoading: false,
}

const reducer = (state, action) => {
  switch (action.type) {
    case ActionType.SET_PUBLICLINK:
      return {
        ...state,
        publicList: action.value,
        isLoading: false,
      }

    case ActionType.SET_LOADER:
      return {
        ...state,
        isLoading: action.value,
      }
    default:
      return state
  }
}

export default function usePublicLink(id) {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { formatMessage } = useIntl()
  const commonDispatch = useDispatch()

  const fetchPublickList = () => {
    dispatch({ type: 'SET_LOADER', value: true })
    effects.apis
      .getPublicNotificationLink({ notificationId: id })
      .then((response) => {
        dispatch({ type: 'SET_PUBLICLINK', value: response })
      })
      .catch(() =>
        commonDispatch(
          MessageAlert.showError({
            message: formatMessage({
              id: 'error.general',
            }),
          }),
        ),
      )
  }

  return {
    state,
    fetchPublickList,
  }
}
